export default "__VITE_ASSET__C7w4XtJW__"